<template>
<div class="chapter">
<div class="inner_page">
<p class="t3b">
CONTENTS<br class="calibre4"/>
</p>
<p class="calibre3"><br class="calibre4"/>
</p>
<p class="calibre3">CHAPTER</p>
<p class="calibre3"><br class="calibre4"/>
</p>
<p class="calibre3"><a href="#/OEBPS/Text/Section00_0003_split_001#Chapter_1">I. BUTTONHOLES</a></p>
<p class="calibre3"><a href="#/OEBPS/Text/Section00_0004#Chapter_2">II. THE POCKET</a></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0005#Chapter_3" title="Link target outside of Sample">III. HENRIETTA'S RED COAT</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0006#Chapter_4" title="Link target outside of Sample">IV. ONE FRIDAY AFTERNOON</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0007#Chapter_5" title="Link target outside of Sample">V. BILLY AND THE DOLL</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0008#Chapter_6" title="Link target outside of Sample">VI. MISS HESTER MEETS AN OLD ACQUAINTANCE</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0009#Chapter_7" title="Link target outside of Sample">VII. A SURPRISE PARTY</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0010#Chapter_8" title="Link target outside of Sample">VIII. A STRANGE VISITOR</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0011#Chapter_9" title="Link target outside of Sample">IX. UNCLE SIDNEY</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0012#Chapter_10" title="Link target outside of Sample">X. HOMESICK</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section00_0013#Chapter_11" title="Link target outside of Sample">XI. SIGNED, SIMON PETTY</span></p>
<p class="calibre3"><span href="#/OEBPS/Text/Section001#Chapter_12" title="Link target outside of Sample">XII. A JOURNEY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section00_0002.vue?703bc721